import { render, staticRenderFns } from "./withdrawList.vue?vue&type=template&id=08fa0446&scoped=true&"
import script from "./withdrawList.vue?vue&type=script&lang=js&"
export * from "./withdrawList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fa0446",
  null
  
)

export default component.exports